import { TileIndex } from "../../types";

export const GO_UP: TileIndex[][] = [
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  [
    1, 21, 22, 22, 22, 22, 22, 22, 22, 16, 16, 16, 8, 15, 10, 16, 16, 16, 16,
    21, 22, 22, 22, 22, 1,
  ],
  [
    1, 21, 23, 23, 23, 23, 21, 16, 20, 22, 22, 22, 22, 26, 22, 22, 22, 22, 22,
    22, 0, 0, 25, 20, 1,
  ],
  [
    1, 21, 20, 23, 16, 16, 21, 20, 0, 0, 0, 20, 23, 23, 23, 23, 21, 0, 23, 23,
    23, 21, 18, 20, 1,
  ],
  [
    1, 21, 5, 23, 23, 21, 21, 20, 22, 22, 22, 0, 22, 22, 22, 22, 22, 22, 16, 0,
    16, 21, 2, 2, 1,
  ],
  [
    1, 21, 20, 16, 16, 21, 21, 0, 23, 23, 21, 22, 23, 23, 23, 23, 21, 20, 16,
    32, 0, 23, 23, 20, 1,
  ],
  [
    1, 21, 20, 16, 16, 16, 21, 20, 0, 0, 21, 22, 20, 16, 16, 16, 21, 20, 0, 9,
    18, 25, 16, 16, 1,
  ],
  [
    1, 21, 20, 16, 16, 16, 21, 20, 0, 0, 21, 22, 20, 16, 20, 16, 21, 2, 22, 2,
    22, 22, 22, 22, 1,
  ],
  [
    1, 21, 20, 16, 16, 0, 21, 20, 0, 0, 21, 22, 20, 16, 20, 0, 23, 0, 23, 23,
    23, 21, 18, 20, 1,
  ],
  [
    1, 21, 20, 22, 0, 0, 21, 20, 22, 22, 22, 22, 12, 23, 20, 15, 15, 21, 22, 16,
    2, 21, 18, 20, 1,
  ],
  [
    1, 21, 0, 20, 0, 0, 21, 20, 0, 23, 23, 23, 21, 22, 22, 15, 15, 21, 22, 18,
    0, 21, 18, 20, 1,
  ],
  [
    1, 21, 0, 20, 0, 0, 21, 20, 22, 2, 23, 23, 21, 0, 20, 15, 15, 21, 22, 19,
    23, 21, 18, 20, 1,
  ],
  [
    1, 21, 22, 2, 22, 0, 21, 0, 0, 20, 16, 16, 21, 0, 20, 22, 22, 22, 0, 20, 0,
    23, 21, 20, 1,
  ],
  [
    1, 21, 3, 21, 20, 0, 23, 23, 23, 0, 23, 23, 23, 23, 23, 23, 23, 23, 23, 2,
    23, 16, 21, 20, 1,
  ],
  [
    1, 21, 22, 22, 2, 21, 21, 17, 17, 21, 0, 21, 22, 22, 22, 22, 22, 22, 22, 22,
    22, 22, 22, 20, 1,
  ],
  [
    1, 21, 0, 0, 20, 4, 21, 17, 17, 21, 6, 21, 0, 0, 23, 23, 23, 23, 23, 23, 23,
    23, 23, 20, 1,
  ],
  [
    1, 21, 0, 0, 20, 0, 21, 17, 17, 21, 0, 23, 23, 23, 2, 23, 23, 23, 23, 23,
    23, 23, 23, 21, 1,
  ],
  [
    1, 23, 23, 23, 20, 0, 23, 23, 3, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22,
    22, 22, 22, 22, 1,
  ],
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
];
